import { useEffect, useLayoutEffect } from 'react';
import { isBrowser } from '../utils/isBrowser.js';

export const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
